import React from 'react';

import { Dropdown, FloatingMenu } from '@zapier/design-system';

import { buildSidebarVersionDropdownItems } from '../utils';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  onChange: (version: SemVer) => {};
  version?: SemVer;
  versions: SemVer[];
};

const Versions = ({ onChange, version, versions }: Props) => {
  return (
    <Dropdown
      aria-label="Versions"
      initialSelectedItem={{ label: `Version ${version}`, value: version }}
      items={buildSidebarVersionDropdownItems(versions, version)}
      menuAriaLabel="List of available versions"
      onSelect={item => onChange(item.value)}
      renderFloatingMenu={menuProps => (
        <FloatingMenu minWidth="180px" {...menuProps} />
      )}
      selectedItem={{ label: `Version ${version}`, value: version }}
    />
  );
};

Versions.defaultProps = {
  versions: [],
};

export default Versions;
